import HarnessTable from './HarnessTable'

export default HarnessTable
